import { useContext } from 'react'

import { I18nContext } from '../I18nProvider/context'

export const useI18n = () => ({ i18n: useContext(I18nContext) })
